<mat-card>
    <mat-card-content>
        @if (canCreateVariation()) {
            <button
                [disabled]="!canGenerateVariations()"
                mat-raised-button
                color="primary"
                (click)="openGenerateVariationDialog()"
            >
                Generate Variation ({{ $numberofUnassignedChangeRecords }})
            </button>
        }
    </mat-card-content>
</mat-card>
